import { useEffect, useState } from 'react'

/**
 * Гарантирует минимальное время показа прелоадера: если загрузка
 * завершилась раньше minMs — лоадер держится до конца минимума,
 * если дольше — ждём реального завершения.
 *
 * @param {boolean} isLoading - реальное состояние загрузки
 * @param {number} minMs - минимальная длительность показа (по умолчанию 2 сек)
 * @returns {boolean} true — прелоадер нужно показывать
 */
const useMinimumLoadingTime = (isLoading, minMs = 1500) => {
  const [minTimeElapsed, setMinTimeElapsed] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setMinTimeElapsed(true), minMs)
    return () => clearTimeout(timer)
  }, [minMs])

  return isLoading || !minTimeElapsed
}

export default useMinimumLoadingTime
